import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FormikProps } from "formik";
import { useRef, useState } from "react";

import AddReserveForm from "@/features/reserves/components/addReserve/AddReserveForm";
import { ReserveBaseModel } from "@/features/reserves/types/reserveModels";
import { RDialog } from "@/shared/components/forms";
import useProjectWBSContext from "@/shared/context/projectWBS/useProjectWBSContext";

export type AddReserveProps = {
  refetchReserve: () => void;
};

export default function AddReserveButton({ refetchReserve }: AddReserveProps) {
  const [isModalOpen, setModalOpen] = useState(false);
  const addFormikRef = useRef<FormikProps<ReserveBaseModel>>(null);
  const { refetchProjectWBS } = useProjectWBSContext();
  const [isFormValid, setIsFormValid] = useState(false);

  const addReserve = async () => {
    if (addFormikRef.current) {
      await addFormikRef.current.submitForm();
    }
    refetchReserve();
    refetchProjectWBS();
  };
  const handleSubmitForm = () => {
    void addReserve();
    handleClose();
  };

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: "white",
        borderRadius: "4px",
        marginTop: "24px",
      }}>
      <Button
        onClick={handleOpen}
        variant="outlined"
        size="large"
        sx={{
          marginTop: "10px",
          marginBottom: "14px",
          marginLeft: "10px",
          fontWeight: "bold",
        }}>
        Add Reserve
      </Button>
      <RDialog
        isOpen={isModalOpen}
        title="Add Reserve"
        confirmButtonCallback={handleSubmitForm}
        cancelButtonCallback={handleClose}
        confirmButtonText="Create"
        confirmButtonType="primary"
        confirmButtonDisabled={!isFormValid}
        size="medium">
        <AddReserveForm innerRef={addFormikRef} setIsFormValid={setIsFormValid} />
      </RDialog>
    </Box>
  );
}
